import auth from "./AuthAPI.js";
import Http from "./Http.js";
import * as APPCONFIG from "../config/app-config.js";
import api from "./BaseAPI.js";

class ResourceDownloadApi {
  saveResourceDownload(formValues) {
    return api({
      method: "post",

      url: `${APPCONFIG.API_URL}auth/resource-download/save`,
      data: formValues,
    });
  }

  checkResourceDownload(resourceId, email) {
    return api({
      method: "get",

      url: `${APPCONFIG.API_URL}auth/resource-download/check`,
      params: { resourceId, email },
    });
  }

  getResourceDownloadsByUser() {
    return api({
      method: "get",

      url: `${APPCONFIG.API_URL}auth/resource-download/user`,
    });
  }

  confirmResourcePayment(formValues) {
    return api({
      method: "post",
      url: `${APPCONFIG.API_URL}auth/resource-download/confirm-payment`,
      data: formValues,
    });
  }
}

export default new ResourceDownloadApi();
